import { ConfigsData } from '../../reducer';

export const getParsedConfigs = (configs: string): ConfigsData => {
	const { generalData, pagesData } = JSON.parse(configs);
	return {
		generalData,
		pagesData,
	};
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/indesignEditor/configs.ts